<template>
    <ion-row class="full-width topping-modal-btn" v-if="!justModal">
        <ion-item button detail class="full-width" data-cy="topping-modal-btn" @click="modalOpen = !modalOpen">
            <ion-label class="ion-padding-start">
                {{ btnName }}
                <inlineList v-if="showToppingPreview" :items="localToppings?.filter((c) => c.selected)" keyName="name" data-cy="inline-toppings" :displayFunc="inlineToppingDisplay" />
            </ion-label>
        </ion-item>
    </ion-row>
    <modalWrapper title="Toppings" :open="modalOpen" @close="close" @dismiss="close" @confirm="$emit('confirm', $event)" data-cy="topping-modal">
        <template v-slot>
            <proteinVeggieSelection
                v-if="copy"
                :availableTopping="availableTopping"
                v-model:toppings="copy"
                :initialItem="initialItem"
                class="protein-veggie list-buffer"
                :hideSplitOpts="hideSplitOpts"
                checklistClass="ion-padding"
                :parentToppingCount="parentToppingCount"
                @blockSubmit="disabled = $event"
                checkCount
                :ignoreTopping="toppingCount - parentToppingCount"
            />
        </template>

        <template v-slot:footer>
            <ion-button color="primary" expand="full" size="large" class="force-bottom interstate-bold full-width ma-0" @click="add" data-cy="button-add-toppings" :disabled="disabled">
                <ion-spinner v-if="loading" name="lines-small" />
                <ion-text v-else> Update Toppings</ion-text>
            </ion-button>
        </template>
    </modalWrapper>
</template>

<script lang="ts">
import { defineComponent, ref, nextTick, watch } from 'vue';
import { IonItem, IonLabel, IonButton, IonRow, IonSpinner, IonText } from '@ionic/vue';
import { inlineToppingDisplay } from '@/services/orderService';
import baseToppings, { passThroughBindings } from '@/components/menu/toppings/baseToppings.vue';
import proteinVeggieSelection from '@/components/menu/toppings/proteinVeggieSelection.vue';
import inlineList from '@/components/inlineList.vue';
import modalWrapper from '@/components/modals/modalWrapper.vue';
import { MenuItem } from '@/models/menuModels';

export default defineComponent({
    extends: baseToppings,
    props: { btnName: String, justModal: Boolean, showToppingPreview: Boolean, initialItem: MenuItem },
    components: { modalWrapper, IonItem, IonLabel, IonButton, IonRow, proteinVeggieSelection, inlineList, IonSpinner, IonText },
    emits: ['close', 'update'],
    setup(props, { emit }) {
        const modalOpen = ref(props.justModal);
        const { localToppings } = passThroughBindings(props, emit);
        const copy = ref();
        const disabled = ref(false);
        const loading = ref(false);
        // If this is not deep copied, the modal updates localToppings directly. (canceling the modal would still emit the changes)
        nextTick(() => (copy.value = JSON.parse(JSON.stringify(localToppings.value))));

        // Salads toppings are updated late; making sure the modal has updated selections when open.
        watch(modalOpen, () => {
            copy.value = JSON.parse(JSON.stringify(localToppings.value));
        });

        const close = () => {
            modalOpen.value = false;
            copy.value = JSON.parse(JSON.stringify(localToppings.value));
            emit('update', JSON.parse(JSON.stringify(copy.value)));
            emit('close');
        };

        const add = () => {
            loading.value = true;
            emit('update', JSON.parse(JSON.stringify(copy.value)));
            setTimeout(() => {
                modalOpen.value = false;
                emit('close');
                loading.value = false;
            }, 1000);
        };

        return { modalOpen, localToppings, copy, disabled, add, close, inlineToppingDisplay, loading };
    },
});
</script>

<style scoped>
ion-item::part(native) {
    padding-left: 0;
}

.topping-modal-btn {
    position: absolute;
    bottom: 0;
    left: 0;
}

.force-bottom {
    position: fixed;
    z-index: 10;
}

ion-modal {
    --min-height: 75vh;
    --min-width: 40vw;
}
</style>
